import { useTranslation } from 'react-i18next';

import { Mail, Phone, User } from 'lucide-react';

interface CaseAdminContactsCardProps {
  caseAdmins: { email: string; full_name: string; contact_phone: string }[];
}

export function CaseAdminContactsCard({ caseAdmins }: CaseAdminContactsCardProps) {
  const { t } = useTranslation();

  if (caseAdmins.length === 0) {
    return (
      <div className="rounded-lg border p-4 text-center text-muted-foreground">
        <User className="h-8 w-8 mx-auto mb-2 opacity-50" />
        <p className="text-sm">{t('track-ack-no-contacts')}</p>
      </div>
    );
  }

  return (
    <div>
      <h4 className="font-semibold mb-3 flex items-center gap-2">
        <User className="h-4 w-4" />
        {t('track-ack-admin-contacts-title')}
      </h4>
      <div className="space-y-3">
        {caseAdmins.map((admin) => (
          <div key={admin.email} className="rounded-lg border p-3 space-y-1">
            <p className="text-sm font-medium">{admin.full_name}</p>
            <a
              href={`mailto:${admin.email}`}
              className="flex items-center gap-2 text-sm text-blue-600 hover:underline"
            >
              <Mail className="h-3 w-3" />
              {admin.email}
            </a>
            <a
              href={`tel:${admin.contact_phone}`}
              className="flex items-center gap-2 text-sm text-blue-600 hover:underline"
            >
              <Phone className="h-3 w-3" />
              {admin.contact_phone}
            </a>
          </div>
        ))}
      </div>
    </div>
  );
}
